function abbreviateNumber(value: number) {
  if (value < 1000) {
    // round to 2 decimal places
    value = Math.round(value * 100) / 100;
    return value;
  }
  if (value < 10000) {
    // round to 0   decimal places
    value = Math.round(value);
    // format with , separator
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (value < 100000) {
    // round to 1 decimal places
    return `${Math.round(value / 100) / 10}K`;
  }
  if (value < 1000000) {
    // round to 0 decimal places
    return `${Math.round(value / 1000)}K`;
  }
  return `${Math.round(value / 1000000)}M`;
}

export function formatTotalMatched(totalMatched: number) {
  return '$' + abbreviateNumber(totalMatched);
}
